import { FileDescriptor } from '@interfaces/models/doc-types';
import { IFileMetaData } from '@store/reducers/document-upload/document-upload.reducer';

export function getFileDescriptorsFromMetadata(filesMetaData: IFileMetaData[]): FileDescriptor[] {
  return filesMetaData
    .filter((f) => f.s3BucketFileName)
    .map((f) => {
      const parts = f.s3BucketFileName!.split('.');
      const fileExtension = parts.pop() || '';
      const filename = parts.join('.');
      return { filename, fileExtension };
    });
}
